import type { HttpClient } from '../http/HttpClient'
import type {
  ManualPaymentSplitCostCenter,
  ManualPaymentSplitEntry,
  ManualPaymentSplitPreview,
  ManualPaymentSplitProblemCode,
  ManualPaymentSplitRepository,
} from '@/domain/payment/ManualPaymentSplit'

interface RawPreview {
  enabled: boolean
  groups: {
    cost_center: ManualPaymentSplitCostCenter | null
    invoice_ids: number[]
    entries?: { invoice_id: number; amount: number }[]
    total: number
  }[]
  invoices: {
    invoice_id: number
    cost_center: ManualPaymentSplitCostCenter | null
    cost_centers?: { cost_center: ManualPaymentSplitCostCenter | null; share: number }[]
  }[]
  problems: { invoice_id: number | null; code: ManualPaymentSplitProblemCode; cost_center_id: number | null }[]
}

export class HttpManualPaymentSplitRepository implements ManualPaymentSplitRepository {
  constructor(private http: HttpClient) {}

  async preview(entries: ManualPaymentSplitEntry[]): Promise<ManualPaymentSplitPreview> {
    const raw = await this.http
      .url('purchases/payments/split-preview')
      .body({ documents: entries })
      .post<RawPreview>()
    return {
      enabled: raw.enabled,
      groups: raw.groups.map((group) => ({
        costCenter: group.cost_center,
        invoiceIds: group.invoice_ids,
        entries: (group.entries ?? []).map((entry) => ({ invoiceId: entry.invoice_id, amount: entry.amount })),
        total: group.total,
      })),
      invoices: raw.invoices.map((row) => ({
        invoiceId: row.invoice_id,
        costCenter: row.cost_center,
        costCenters: (row.cost_centers ?? []).map((item) => ({ costCenter: item.cost_center, share: item.share })),
      })),
      problems: raw.problems.map((problem) => ({
        invoiceId: problem.invoice_id,
        code: problem.code,
        costCenterId: problem.cost_center_id,
      })),
    }
  }
}
